<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-container class="pt-0 pl-0 white" fluid>
    <v-layout class="justify-space-around mt-2 pb-2 pr-1 pl-0" row>
      <MapContainer>
        <world-map
          v-if="
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
              .C_Code.length === 1 &&
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
                .HS6_Code.length === 1
          "
        />
        <WorldMap_MPMC v-else />
      </MapContainer>

      <v-flex v-if="!$store.state.app.big_map" class="mt-2" lg7 md12 sm12 xl6>
        <top-summary-results class="mb-2" />
        <dsm-single-text-prod-country class="ma-0 pa-0 align-center white" />
      </v-flex>
    </v-layout>

    <template
      v-if="
        !$store.state.tradeDSM.loading_indicator &&
          !$store.state.app.big_map &&
          !$store.state.tradeDSM.productsOpen &&
          !$store.state.tradeDSM.countriesOpen &&
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
            .combinations > 0
      "
    >
      <tabbed_graph_view caption="Trade statistics and trends" help_id="8"></tabbed_graph_view>
    </template>
  </v-container>
</template>
<script>
// import DSMSingleGraphs from '@/components/trade-dsm-application/result-components/graphs-1p1c';
import DsmSingleTextProdCountry from '@/components/trade-dsm-application/result-components/text-summary-1p1c';
import TopSummaryResults from '@/components/trade-dsm-application/result-components/top-summary-results';
import MapContainer from '@/components/trade-dsm-application/result-components/helpers/map-container';
import worldMap from '@/components/trade-dsm-application/graphs/1p1c/world-map-1p1c';
import WorldMap_MPMC from '@/components/trade-dsm-application/graphs/mpmc/world-map-mpmc';
import tabbed_graph_view from '@/components/trade-dsm-application/results-pages/tabs/tabbed_graph_view.vue';

export default {
  name: 'tab1p1c',
  components: {
    tabbed_graph_view,
    MapContainer,
    DsmSingleTextProdCountry,
    TopSummaryResults,
    worldMap,
    WorldMap_MPMC,
  },
  computed: {
    show_results() {
      return (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
          .markets_count === 1 &&
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
          .products_count === 1
      );
    },
  },

  data() {
    return {
      big_map: false,
    };
  },
  props: {
    map_rerender_workarount: {},
  },
};
</script>